import React, { useState, useEffect } from 'react'

import PropTypes from 'prop-types'
import { isEmpty } from 'lodash'
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
} from '@material-ui/core'

import { LoadingButton } from 'components'

import useStyles from './styles'

const BulkActionDialog = ({
  open,
  setOpen,
  title,
  description,
  warning,
  confirmText = 'Confirmar',
  renderFields,
  validateFields,
  loading = false,
  onConfirm,
}) => {
  const [values, setValues] = useState({})
  const [errors, setErrors] = useState({})

  const classes = useStyles()

  const setValue = (name, value) => {
    setValues((currentValues) => ({ ...currentValues, [name]: value }))
    setErrors((currentErrors) => ({ ...currentErrors, [name]: undefined }))
  }

  const handleClose = () => setOpen(false)

  const handleConfirm = () => {
    const validationErrors = validateFields ? validateFields(values) : {}

    if (!isEmpty(validationErrors)) return setErrors(validationErrors)

    onConfirm(values)
  }

  useEffect(() => {
    if (open) {
      setValues({})
      setErrors({})
    }
  }, [open])

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="bulk-action"
      fullWidth
    >
      <DialogTitle>
        <Typography variant="h5">{title}</Typography>
      </DialogTitle>
      <Divider />
      <DialogContent>
        <Box pb={1}>
          <Typography>{description}</Typography>
          {warning && (
            <Box mt={1}>
              <Typography variant="body2" color="textSecondary">
                {warning}
              </Typography>
            </Box>
          )}
          {renderFields && (
            <Box mt={2}>{renderFields({ values, setValue, errors })}</Box>
          )}
        </Box>
      </DialogContent>
      <Divider />
      <DialogActions className={classes.dialogActions}>
        <Button type="button" variant="outlined" onClick={handleClose}>
          Cancelar
        </Button>
        <LoadingButton
          variant="contained"
          color="primary"
          text={confirmText}
          loading={loading}
          onClick={handleConfirm}
        />
      </DialogActions>
    </Dialog>
  )
}

BulkActionDialog.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func.isRequired,
  title: PropTypes.string,
  description: PropTypes.node,
  warning: PropTypes.node,
  confirmText: PropTypes.string,
  renderFields: PropTypes.func,
  validateFields: PropTypes.func,
  loading: PropTypes.bool,
  onConfirm: PropTypes.func.isRequired,
}

export default BulkActionDialog
